import React from 'react';
import { ListUl } from 'styled-icons/boxicons-regular/ListUl';

function ListBulletIcon(props) {
  return (
    <ListUl {...props} className={'icon'} />
  );
}

export default ListBulletIcon;
